<template>
  <div class="forms">
    <div class="body">
      <form class="form" novalidate autocomplete="off" @submit.prevent="submit">
        <div class="row">
          <div class="col">
            <h3 class="title">1. Clinic information</h3>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="label">Clinic (Required)</div>
            <div class="input-wrap">
              <div class="icon icon-paw"/>
              <input
                id="clinic"
                v-model="account.clinic"
                :class="{ 'error': $v.account.clinic.$error }"
                type="text"
                name="clinic"
                placeholder="Crossroads Animal Clinic"
                required="required"
                class="input"
                @input="$v.account.clinic.$touch()"
              >
              <label
                v-if="$v.account.clinic.$error && !$v.account.clinic.required"
                class="error"
                for="name"
              >This field is required.</label>
            </div>
          </div>
          <div class="col">
            <div class="label">Phone</div>
            <div class="input-wrap">
              <div class="icon icon-phone"/>
              <input
                v-mask="'(###) ###-####'"
                id="phone"
                v-model="account.phone"
                :class="{ 'error': $v.account.phone.$error }"
                type="text"
                name="phone"
                placeholder="(832) 823-2381"
                required="required"
                class="input phone"
                @input="$v.account.phone.$touch()"
              >
              <label
                v-if="$v.account.phone.$error && !$v.account.phone.minLength"
                class="error"
                for="name"
              >Minimal length is 10 numbers.</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="label">Fax</div>
            <div class="input-wrap">
              <div class="icon icon-fax"/>
              <input
                v-mask="'(###) ###-####'"
                id="fax"
                v-model="account.fax"
                :class="{ 'error': $v.account.fax.$error }"
                type="text"
                name="fax"
                placeholder="(832) 823-2381"
                required="required"
                class="input fax"
                @input="$v.account.fax.$touch()"
              >
              <label
                v-if="$v.account.fax.$error && !$v.account.fax.minLength"
                class="error"
                for="name"
              >Minimal length is 10 numbers.</label>
            </div>
          </div>
          <div class="col">
            <div class="label">Email (Required)</div>
            <div class="input-wrap">
              <div class="icon icon-mail"/>
              <input
                id="email"
                v-model="account.email"
                :class="{ 'error': $v.account.email.$error }"
                type="text"
                name="email"
                placeholder="info@crossroads.com"
                required="required"
                class="input"
                @input="$v.account.email.$touch()"
              >
              <label
                v-if="$v.account.email.$error && !$v.account.email.required"
                class="error"
                for="name"
              >This field is required.</label>
              <label
                v-if="$v.account.email.$error && !$v.account.email.email"
                class="error"
                for="name"
              >Valid email is required.</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="label">Address</div>
            <div class="input-wrap">
              <div class="icon icon-location"/>
              <input
                id="streetAddress"
                v-model="account.address"
                type="text"
                name="email"
                placeholder="Street Address"
                required="required"
                class="input"
              >
            </div>
          </div>
          <div class="col">
            <div class="label">State</div>
            <div class="input-wrap">
              <div class="icon icon-shield"/>
              <input
                id="state"
                v-model="account.state"
                type="text"
                name="state"
                placeholder="Texas"
                required="required"
                class="input text"
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="label">City</div>
            <div class="input-wrap">
              <div class="icon icon-building"/>
              <input
                id="city"
                v-model="account.city"
                type="text"
                name="city"
                placeholder="Houston"
                required="required"
                class="input text"
              >
            </div>
          </div>
          <div class="col">
            <div class="label">Zip</div>
            <div class="input-wrap">
              <div class="icon icon-shield"/>
              <input
                v-mask="getZipMask(account.zip)"
                id="zip"
                v-model="account.zip"
                type="text"
                name="state"
                placeholder="77056"
                required="required"
                class="input number"
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3 class="title mt-40 mt-d-20">2. Doctor information</h3>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="label">Doctor (Required)</div>
            <div class="input-wrap">
              <div class="icon icon-user"/>
              <input
                id="doctor"
                v-model="account.doctor"
                :class="{ 'error': $v.account.doctor.$error }"
                type="text"
                name="doctor"
                placeholder="Dr. Josh Engalla"
                required="required"
                class="input"
                @input="$v.account.doctor.$touch()"
              >
              <label
                v-if="$v.account.doctor.$error && !$v.account.doctor.required"
                class="error"
                for="name"
              >This field is required.</label>
            </div>
          </div>
          <div class="col">
            <div class="label">DEA No</div>
            <div class="input-wrap">
              <div class="icon icon-certificate"/>
              <input
                id="deaNo"
                v-model="account.dea_no"
                type="text"
                name="deaNo"
                placeholder="1823-AF100"
                required="required"
                class="input number"
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="label">License No (Required)</div>
            <div class="input-wrap">
              <div class="icon icon-certificate"/>
              <input
                id="license_no"
                v-model="account.license_no"
                :class="{ 'error': $v.account.license_no.$error }"
                type="text"
                name="license_no"
                placeholder="1823-AF100"
                required="required"
                class="input"
                @input="$v.account.license_no.$touch()"
              >
              <label
                v-if="$v.account.license_no.$error && !$v.account.license_no.required"
                class="error"
                for="name"
              >This field is required.</label>
            </div>
          </div>
          <div class="col">
            <div class="label">License State</div>
            <div class="input-wrap">
              <div class="icon icon-shield"/>
              <input
                id="licenseState"
                v-model="account.license_state"
                type="text"
                name="licenseState"
                placeholder="Texas"
                required="required"
                class="input text"
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h3 class="title mt-40 mt-d-20">3. Account Info</h3>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="label">Password</div>
            <div class="input-wrap">
              <div class="icon icon-user"/>
              <input
                id="password"
                v-model="account.password"
                type="password"
                name="password"
                required="required"
                class="input"
                placeholder="Type to change"
                autocomplete="new-password"
              >
            </div>
          </div>
          <div class="col">
            <div class="label">Confirm Password</div>
            <div class="input-wrap">
              <div class="icon icon-user"/>
              <input
                v-model="account.repeat_password"
                :class="{ 'error': $v.account.repeat_password.$error }"
                type="password"
                required="required"
                class="input"
                name="repeat_password"
                autocomplete="new-password"
                placeholder="Repeat password"
                @input="$v.account.repeat_password.$touch()"
              >
              <label
                v-if="$v.account.repeat_password.$error && !$v.account.repeat_password.sameAsPassword"
                class="error"
                for="name"
              >Passwords must be identical.</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button type="submit" class="btn wide">Save</button>
          </div>
          <div class="col"/>
        </div>
        <sweet-modal
          ref="account_modal"
          :blocking="true"
          :hide-close-button="true"
        >
          <div style="text-align: center;">
            <div class="modal-close-btn cross"><span class="icon-cross"/></div>
            <div class="modal-body">
              <h2 class="title">Success!</h2>
              <div class="notification-block">
                <p>Your account information has been changed successfully.</p>
                <div class="button-wrap">
                  <button class="btn modal-close-btn" style="margin: 15px auto 0;" @click="confirmModal">Ok</button>
                </div>
              </div>
            </div>
          </div>
        </sweet-modal>
      </form>
    </div>
  </div>
</template>

<script>
/* global axios */
import { required, sameAs, email, minLength } from 'vuelidate/lib/validators'
import { SweetModal } from 'sweet-modal-vue'
import ZipMask from './../../mixins/ZipMask'
import ValidateScroll from '../../mixins/ValidateScroll'

export default {
  name: 'AccountForm',
  components: {
    SweetModal
  },
  mixins: [ZipMask, ValidateScroll],
  data: () => {
    return {
      account: {}
    }
  },
  validations: {
    account: {
      clinic: {
        required
      },
      email: {
        required,
        email
      },
      phone: {
        minLength: minLength(10)
      },
      fax: {
        minLength: minLength(10)
      },
      doctor: {
        required
      },
      license_no: {
        required
      },
      repeat_password: {
        sameAsPassword: sameAs('password')
      }
    }
  },
  mounted () {
    let that = this
    axios
      .get('/veterinarians/internal/account-info')
      .then(response => {
        if (response && response.data && response.data.result === 'ok') {
          that.account = response.data.account
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    submit () {
      this.validateWithScroll()
      if (!this.$v.$invalid) {
        let formData = new FormData()

        for (var key in this.account) {
          formData.append(key, this.account[key])
        }

        axios
          .post('/veterinarians/internal/account-info', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.$refs.account_modal.open()
            } else {
              console.log(response.data.message)
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    confirmModal () {
      window.location = '/veterinarians/internal'
      this.$refs.account_modal.close()
    }
  }
}
</script>

<style>
</style>
